import { axiosClient } from 'www/utils'
import type {
  ApiLpuTypesParamsGet,
  ApiLpuTypesResponseGet,
} from 'www/vue_components/common/TheFilters/lpu/api/apiLpuTypes.types'

export default {
  get(params: ApiLpuTypesParamsGet) {
    return axiosClient.get<ApiLpuTypesResponseGet>('/api/town/lpu-types/', { params })
  },
}
